import { IFacettes } from "./IFacette";
import { DisponibiliteEtendu } from "./IDisponibiliteEtendu";
import { IReturn_Parent } from "./IReturn_Parent";

export interface INoticeDetails extends INotice {
  ImageCouverture: string;
  prixTTC: number,
  prixDevise: string,
  resumeElectre : string,
  distributeur : string,
  OrigineContenu : string,
  typeProduitId :string,
  formeBibEditeur :string,
  Theme :string,
  genres : IGenre[],
  publics: IPublic[],
  deweys :IDewey[],
  DesciptionPhysique : IDescriptionPhysique,
  groupeTitres : IGroupeTitres,
  Auteurs : IAuteur[],
  Bloc3 : IBloc3,
  ISBN : string,
  Editeurs : IEditeur[]
  libelleTypeProduit: string,
  MentionsEdition: string,
  coffret: boolean,
  serie : ISerie[],
  collection : ICollection[],
  notes : INote[],
  vedettesMatieres : IVedetteMatiere[],
  nouvellesEditionsEan : string[],
  anciennesEditionsEan : string[],
  autresFormats :IAutreFormat[],
  SuiviPar : string,
  LivreEnMain : boolean,
}
export interface INotice {
  Id : string;
  Ean: string;
  EansJustes: string[];
  Titre: string;
  Editeur: string;
  disponibiliteEtendue: number,
  dateParution: string,
  prixDevise: string,
  prixTTC: number,
  Auteur: string,
  ImageCouverture: string,
  distributeur : string,
  OrigineContenu : string,
  Source:string,
  Support :ISupport,
  DemandesAuto :number,
  DemandesMessages :number,
  FormatEbook :string

}
export interface INotices {
    Quantite?: number;
    Notices: INotice[];
    Facettes: IFacettes;
  }

  export interface INoticesReturn extends INotices, IReturn_Parent {
  }


  export interface INoticeReturn extends IReturn_Parent {
    Notice: INotice;
  }

  export interface INoticeDetailsReturn extends IReturn_Parent {
    NoticeDetails: INoticeDetails;
  }



  export interface INoticeDemandeChamp {
    IdPersonneDemande : number;
    LibelleChamp: string;
    ValeurActuelle: string;
    ValeurDemande: string;
    DateCreation: string,
    DateMaj: string,
   }
  export interface INoticeDemande {
    Id: number;
    Ean: string;
    IdNotice: string;
    IdEtat : number,
    DateTraitement: string,
    DateCreation: string,
    DateMaj : string,
    Champs: INoticeDemandeChamp[]
  }
  
  export interface INoticesDemandesReturn extends IReturn_Parent {
    Quantite: number;
    Demandes: INoticeDemande[];
  }
  
  export interface INoticeDemandeReturn extends IReturn_Parent {
    Demande: INoticeDemande;
  }
  

export interface IDescriptionPhysique {
  reliure :string,
  nbVolumes : number,
  nbPages : string,
  typeVolume : string,
  mentionIllustrations : string,
  hauteur : number,
  largeur : number, 
  epaisseur : number,
  poids : number,
  duree : string,
  materielsAccompagnement : string[]
}
export interface IDroitsEbook{
  utilisation : string,
  limitation : string,
}
export interface IpackEbookContenu{
  formatEbookContenu: string,
  eanEbookContenu: string,
  poidsEbookContenu: string,
  protectionEbookContenu: string,
  descriptionEbookContenu: string,
  venduSeul: string,
  droitsEbookContenu: IDroitsEbook[],
}
export interface IDescriptionsEbook{
  resumeEbook : string,
  formatEbook : string,
  protectionEbook : string,
  poidsEbook : string,
  droitsEbook : IDroitsEbook[],
  packEbookContenus : IpackEbookContenu[],
  caracteristiqueFormat? : string
}
export interface IBloc3{
  quatriemeDeCouverture : string,
  extrait : string,
  tableDesMatieres : string,
  biographie :string,
  descriptionsEbook : IDescriptionsEbook,
}

  export interface IAuteur {
    formebib :string,
    idBnf : string
  }
 export interface ISupport {
  supportId:string,
  libelleSupport:string,
 }
 export interface ICollection {
  libelleCollection:string,
  noDeCollection:string,
  sousCollection:ISousCollection,
 }
 export interface ISousCollection {
  libelleSousCollection:string,
  noDeSousCollection:string,
  sousSousCollection:ISousSousCollection,
 }
 export interface ISousSousCollection {
  libelleSousSousCollection:string,
  noDeSousSousCollection:string,
 }
 export interface ISerie {
  titreSerie:string,
  numeroSerie:string,
 }
 export interface IType {
  libelleNote:string,
 }
 export interface INote {
  type :IType,
  contenuNote:string,
 }

export interface IEditeur{
  editeurId : string,
  editeurLibelle : string,
}
export interface IGenre{
  GenreId : string,
  LibelleGenre : string,
}
export interface IPublic{
  PublicId : string,
  LibellePublic : string,
}
export interface IDewey{
  CodeDewey : string,
  LibelleDewey : string,
}
export interface IAutorite{
  FormeBibAutorite : string,
}
export interface IVedetteMatiere{
  Rang : number,
  Autorites : IAutorite[],
}
export interface IGroupeTitres{
  titresPrincipaux:ITitresPrincipaux[],
  titresContenus:ITitresContenus[],
}
export interface ITitresPrincipaux{
  titres:ITitre[],
  mentions:string[],
}
export interface ITitresContenus{
  titres:ITitre[],
  mentions:string[],
}
export interface ITitre{
  libelle:string,
}
export interface IAutreFormat{
  formatLivreLie : string,
}
export interface INoticeDTO {
  Ean: string;
  Titre: string;
  Editeur: string;
  disponibiliteEtendue: DisponibiliteEtendu,
  dateParution: string,
  Auteur: string,
  prix: string,
  resumeElectre : string,
}
export function transformNotices(notices: INotice[]): INotice[] {
  return notices.map(notice => ({
    ...notice,
    prix: transformNoticePrice(notice.prixTTC, notice.prixDevise),

  }));
}

export function transformNoticePrice(prixTTC: number, prixDevise: string): string {
  if (prixDevise === "EUR") {
    prixDevise = "€"
  }
    
  return `${prixTTC} ${prixDevise}`
}
export interface IimageCouverture{
  noticeImage : string;
}
export interface INoticeGet {
  EAN : string;
  IdNotice : string;
}

export interface INoticeGetSecure {
  ParamE : string;
  ParamI : string;
}


export interface INoticeDemandeGet {
  EAN : string;
  IdNotice : string;
  IdDemande : number;
}

export interface INoticeDemandeChampCreateUpdate {
  LibelleChamp: string;
  ValeurActuelle: string;
  ValeurDemande: string;
 }

export interface ICreateUpdateNoticeDemande {
  EAN : string;
  IdNotice : string;
  Id?:number;
  Champs?: INoticeDemandeChampCreateUpdate[];
  NoticeMarques? : number[];
}